import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let createCustomerValidationForm = yup.object().shape({
  full_name: yup.string().required("Name is required"),
  mobile_number: yup.string().required("Mobile Number is required"),
  address: yup.string().required("Address is required"),
});

let createConsignmentValidationForm = yup.object().shape({
  vendor: yup.string().optional().nullable(),
  pickup_branch: yup.string().required("Pickup Branch is required"),
  destination: yup.string().required("Destination is required"),
  sender_full_name: yup.string().required("Sender Full Name is required"),
  sender_phone_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  sender_vat_pan: yup.string().optional().nullable(),
  sender_address: yup.string().required("Sender Address is required"),
  receiver_full_name: yup.string().required("Receiver Full Name is required"),
  receiver_phone_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  receiver_vat_pan: yup.string().optional().nullable(),
  receiver_address: yup.string().required("Receiver Address is required"),
  reference_number: yup.string().optional().nullable(),
  cod: yup.string().required("Cod is required"),
  piece: yup.string().optional().nullable(),
  remark: yup.string().optional().nullable(),
  service_type: yup.string().required("Service Type is requried"),
  payment_method: yup.string().required("Payment Method is requried"),
  reference_type: yup.string().optional().nullable(),
  reference_date: yup.string().optional().nullable(),
  order_value: yup.string().optional().nullable(),
  delivery_charge: yup
    .number()
    .typeError("Freight charge must be a number")
    .required("Freight charge is required"),
  extra_charges: yup.object().shape({
    st: yup.number().optional().nullable().typeError("St must be a number"),

    total_charge: yup
      .number()
      .optional()
      .nullable()
      .typeError("Total charge must be a number"),
  }),
  order_items: yup
    .array()
    .of(
      yup.object().shape({
        remark: yup.string().optional().nullable(),
        package_type: yup
          .object()
          .required("Product Type is required")
          .typeError("Product Type is required"),
        calculated_by: yup
          .object()
          .required("Unit is required")
          .typeError("Unit is required"),
        piece: yup
          .number()
          .typeError("Piece must be a number")
          .required("Piece is required")
          .positive("Piece must be greater than 0")
          .integer("Piece must be an integer"),
        weight: yup
          .number()
          .typeError("Weight must be a number")
          .required("Weight is required")
          .integer("Weight must be a number")
          .when("calculated_by", {
            is: (value) => value === "kg",
            then: (schema) => schema.min(1, "Weight must be a positive or 1"),
            otherwise: (schema) =>
              schema.min(0, "Weight must be a positive or 0"),
          }),
        rate: yup
          .number()
          .typeError("Rate must be a number")
          .required("Rate is required"),
      })
    )
    .min(1, "At least one order item is required")
    .required("Order items are required"),
});

let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required("Remark is required"),
});
const emailDownloadValidationForm = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  date_range: yup.string().required("Date range is required"),
});

const deliveryformValidation = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  primary_contact: yup
    .string()
    .required("Phone Number is required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch {
        return false;
      }
    }),
  signature: yup
    .mixed<File>()
    .required("Signature is required")
    .test("file-exists", "Signature is required", (value) => {
      return value instanceof File;
    }),
});

export {
  createCustomerValidationForm,
  orderRemarksValidationForm,
  createConsignmentValidationForm,
  emailDownloadValidationForm,
  deliveryformValidation,
};
